import { PRIO } from '../../../constants';

export const UPDATE_MAIL_COMPONENTS_ZOOM_FACTOR =
  PRIO + 'UPDATE_MAIL_COMPONENTS_ZOOM_FACTOR';

export const updateMailComponentsZoomFactor = (zoomFactor: number) => ({
  type: UPDATE_MAIL_COMPONENTS_ZOOM_FACTOR,
  payload: zoomFactor,
});

export const UPDATE_MAIL_COMPONENTS_ZOOM_PANEL_PINNED_STATE =
  PRIO + 'UPDATE_MAIL_COMPONENTS_ZOOM_PANEL_PINNED_STATE';

export const updateMailComponentsZoomPanelPinnedState = (pinned: boolean) => ({
  type: UPDATE_MAIL_COMPONENTS_ZOOM_PANEL_PINNED_STATE,
  payload: pinned,
});
